import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

const WarningModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  body,
  yesButtonText,
  noButtonText,
  onCustomAction,
  customButtonText,
  children
}) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        <div style={{ color: 'red' }}>{title || 'Warning'}</div>
      </ModalHeader>
      <ModalBody>
        <div>{body || children}</div>
      </ModalBody>
      <ModalFooter
        className={customButtonText ? 'modalFooterEpiDelete extraButton' : 'modalFooterEpiDelete'}
      >
        <Button outline color="secondary" onClick={onCancel}>
          {noButtonText || 'No'}
        </Button>
        <Button color="primary" onClick={onConfirm}>
          {yesButtonText || 'Yes'}
        </Button>
        {customButtonText && (
          <Button outline color="secondary" onClick={onCustomAction}>
            {customButtonText || 'No'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default WarningModal;
